import { render, staticRenderFns } from "./MoreInfoDialog.vue?vue&type=template&id=a718855e"
import script from "./MoreInfoDialog.vue?vue&type=script&lang=js"
export * from "./MoreInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./MoreInfoDialog.vue?vue&type=style&index=0&id=a718855e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports